<div class="d-flex flex-column main-container">
  <app-toolbar (toggleSidenav)="onToggleSidenav()"></app-toolbar>

  <div class="d-flex align-items-stretch w-100 flex-grow-1">
    <nav @openClose *ngIf="showSidenav && user$ | async">
      <app-sidenav></app-sidenav>
    </nav>

    <div [class.loading]="isLoading" class="container-fluid main-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
</div>


